import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';

const publicNavItems = [
  { path: '/pricing', label: 'Pricing' },
  { path: '/contact', label: 'Contact' },
  { path: '/terms', label: 'Terms' },
  { path: '/privacy', label: 'Privacy' },
];

const PublicNavbar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 bg-white/70 backdrop-blur-xl border-b border-gray-100/50">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_kidplay-hub/artifacts/7zuwi818_jgzjhpdo_image.png"
              alt="SmartDaddy AI"
              className="h-8 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Nav - Floating Pill Style */}
          <nav 
            className="hidden md:flex items-center gap-1 p-1.5 rounded-full"
            style={{
              background: 'rgba(0,0,0,0.04)',
            }}
          >
            {publicNavItems.map(({ path, label }) => (
              <Link
                key={path}
                to={path}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                  location.pathname === path
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-500 hover:text-gray-900'
                }`}
              >
                {label}
              </Link>
            ))}
          </nav>

          {/* Auth Actions */}
          <div className="flex items-center gap-3">
            {user ? (
              <>
                <Button 
                  onClick={() => navigate('/dashboard')} 
                  className="rounded-full bg-gradient-to-r from-purple-600 to-indigo-600"
                >
                  Go to Dashboard
                </Button>
                {/* BETA Badge */}
                <span className="hidden md:inline-flex px-2.5 py-1 bg-gradient-to-r from-purple-600 to-indigo-600 text-white text-[10px] font-bold rounded-full shadow-sm">
                  BETA
                </span>
              </>
            ) : (
              <>
                <Link to="/handler/sign-in" className="text-sm font-medium text-gray-600 hover:text-gray-900">
                  Sign In
                </Link>
                <Button 
                  onClick={() => navigate('/handler/sign-up')} 
                  className="rounded-full bg-gradient-to-r from-purple-600 to-indigo-600"
                >
                  Get Started
                </Button>
                {/* BETA Badge */}
                <span className="hidden md:inline-flex px-2.5 py-1 bg-gradient-to-r from-purple-600 to-indigo-600 text-white text-[10px] font-bold rounded-full shadow-sm">
                  BETA
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default PublicNavbar;
